import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import actions, { useActions } from "../../../redux/actions";
import Breadcrumb from "../../../components/common/breadcrumb.component";
import Loading from "../../../components/loading";
import CampaignsList from "./table";

const Campaigns = (props) => {
  const { t, i18n } = useTranslation();
  const { token } = useSelector((state) => state.account);
  const [isLoading, setIsLoading] = useState(false);
  const campaign = useSelector((state) => state.campaign);
  const campaignActions = useActions(actions.CampaignActions);
  const carpark = useSelector((state) => state.carpark);
  const carparkActions = useActions(actions.CarparkActions);
  const accountActions = useActions(actions.AccountActions);

  useEffect(() => {
    setIsLoading(true);
    campaignActions.getList(
      {},
      token,
      () => {
        setIsLoading(false);
      },
      (error) => {
        const { responseCode } = error || {};
        if (responseCode === 403) {
          window.alert(t("login.unauthorized"));
          accountActions.logout();
          window.location = `/${i18n.language}`;
        }
        setIsLoading(false);
      }
    );
    carparkActions.getList(
      token,
      () => {
        setIsLoading(false);
      },
      (error) => {
        const { responseCode } = error || {};
        if (responseCode === 403) {
          window.alert(t("login.unauthorized"));
          accountActions.logout();
          window.location = `/${i18n.language}`;
        }
        setIsLoading(false);
      }
    );
  }, []);
  return (
    <div>
      <Breadcrumb
        title={t("profile.campaigns.title")}
        parent={t("profile.title")}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div className="table-responsive">
                  {isLoading ? (
                    <Loading />
                  ) : (
                    <CampaignsList
                      campaigns={campaign.list}
                      carparks={carpark.list}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Campaigns);
